export type TimezoneFilterSource = 'manual_override' | 'campaign_timezone' | 'none';

export interface ManualDialSelectionMeta {
  timezoneFilterApplied: boolean;
  areaCodePriorityApplied: boolean;
  activeTimezones: string[];
  dbTimezoneValues: string[];
  etStatsDate: string;
  source?: TimezoneFilterSource;
  effectiveTimezone?: 'Eastern' | 'Central' | 'Mountain' | 'Pacific' | 'Unknown' | null;
}

export function buildTimezoneFilterMessage(selectionMeta: ManualDialSelectionMeta, timezoneFilter: string): string {
  if (selectionMeta.source === 'manual_override') {
    const tz = selectionMeta.effectiveTimezone || selectionMeta.dbTimezoneValues[0] || timezoneFilter;
    return `Filtering by selected timezone: ${tz}.`;
  }

  if (selectionMeta.source === 'campaign_timezone' && selectionMeta.effectiveTimezone) {
    return `Auto mode: filtering by campaign timezone (${selectionMeta.effectiveTimezone}).`;
  }

  if (selectionMeta.timezoneFilterApplied && selectionMeta.dbTimezoneValues.length > 0) {
    return `Filtering by timezone: ${selectionMeta.dbTimezoneValues.join(', ')}.`;
  }

  return 'Timezone filter is not applied (campaign timezone is unsupported).';
}
